<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                {{ building.name }}
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <address>
                  {{ building.address1 }}
                  <br />
                  <template v-if="building.address2">
                    {{ building.address2 }}
                    <br />
                  </template>
                  <template v-if="building.address3">
                    {{ building.address3 }}
                    <br />
                  </template>
                  <template v-if="building.city">
                    {{ building.city }}
                    <br />
                  </template>
                  <template v-if="building.county">
                    {{ building.county }}
                    <br />
                  </template>
                  <template v-if="building.country">
                    {{ building.country }}
                    <br />
                  </template>
                  {{ building.postcode }}
                </address>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Client</strong>
                  <br />
                  <router-link
                    :to="{
                      name: 'Client Details',
                      params: { clientId: building.clientId }
                    }"
                    >{{ building.clientName }}</router-link
                  >
                </p>
                <p>
                  <strong>Site</strong>
                  <br />
                  <router-link
                    :to="{
                      name: 'Site Details',
                      params: { siteId: building.siteId }
                    }"
                    >{{ building.siteName }}</router-link
                  >
                </p>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Plant</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <plantList></plantList>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PlantList from "./components/PlantListing";

export default {
  components: {
    PlantList
  },
  computed: {
    ...mapGetters({
      building: "portfolio/building"
    })
  },
  async created() {
    await this.$store.dispatch(
      "portfolio/getBuilding",
      this.$route.params.buildingId
    );
  },
  methods: {}
};
</script>

<style></style>
